import { motion } from "framer-motion";
import * as Fa from "react-icons/fa";
import { WHY_CHOOSE } from "../data/content";

const WhyChoose = () => (
    <section data-testid="why-choose-section" className="relative py-20 sm:py-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            <motion.div
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                className="relative"
            >
                <div className="aspect-[4/5] rounded-[2rem] overflow-hidden shadow-2xl">
                    <img src="https://images.pexels.com/photos/7585018/pexels-photo-7585018.jpeg?auto=compress&cs=tinysrgb&w=900"
                         alt="Biomedical engineer servicing equipment"
                         loading="lazy"
                         className="w-full h-full object-cover" />
                </div>
                <div className="absolute -bottom-6 -right-2 sm:-right-8 glass-strong rounded-2xl p-5 shadow-xl">
                    <div className="text-4xl font-heading font-extrabold text-gradient-brand">5.0★</div>
                    <div className="text-xs text-slate-500 dark:text-slate-400 mt-1">120+ Google Reviews</div>
                </div>
            </motion.div>

            <div>
                <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
                    <div className="text-xs font-bold uppercase tracking-[0.25em] text-brand-600 dark:text-brand-300 mb-4">Why Ezhil Biomedical</div>
                    <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 dark:text-white">
                        Healthcare Pros{" "}
                        <span className="text-gradient-brand">Trust Us</span>
                    </h2>
                    <p className="mt-4 text-slate-600 dark:text-slate-300">Six clear reasons why hospitals across South India choose us as their preferred biomedical partner.</p>
                </motion.div>

                <div className="mt-10 grid sm:grid-cols-2 gap-5">
                    {WHY_CHOOSE.map((w, i) => {
                        const Icon = Fa[w.icon] || Fa.FaCheck;
                        return (
                            <motion.div
                                key={w.title}
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.4, delay: i * 0.05 }}
                                data-testid={`why-card-${i}`}
                                className="flex gap-4 p-5 rounded-2xl bg-white dark:bg-slate-900 border border-slate-200/70 dark:border-slate-800 hover:shadow-lg transition-all"
                            >
                                <div className="w-11 h-11 flex-shrink-0 rounded-xl bg-brand-50 dark:bg-brand-900/30 text-brand-700 dark:text-brand-300 flex items-center justify-center">
                                    <Icon />
                                </div>
                                <div>
                                    <h3 className="font-heading font-semibold text-slate-900 dark:text-white">{w.title}</h3>
                                    <p className="mt-1 text-sm text-slate-600 dark:text-slate-300">{w.desc}</p>
                                </div>
                            </motion.div>
                        );
                    })}
                </div>
            </div>
        </div>
    </section>
);

export default WhyChoose;
